
import {Component, Prop, Vue} from 'vue-property-decorator';
@Component
export default class Reports extends Vue {
  @Prop({default: '80%'}) readonly width!: string;
  @Prop() readonly title!: string;
  @Prop({default: 'right'}) readonly placement!: string;
  @Prop() readonly visible!: boolean;
  @Prop() readonly destroyOnClose!: boolean;
  onClose(): void {
    this.$emit('close');
  }
  onDelete(): void {
    this.$emit('delete');
  }
  onEdit(): void {
    this.$emit('edit');
  }
}
